import { EventTypes, track, getPageSource } from '@mc/track-event'
import { BOGO_PROPS } from '../../lib/constants'

type Location =
  | (typeof BOGO_PROPS.OFFER_PAGE.LOCATION)[keyof typeof BOGO_PROPS.OFFER_PAGE.LOCATION]
  | typeof BOGO_PROPS.PROMO_MODAL.LOCATION
  | typeof BOGO_PROPS.PROMO_BANNER.LOCATION

export const trackBogoCtaClicked = ({
  action,
  href,
  location,
}: {
  action: string
  href: string
  location: Location
}) =>
  track(EventTypes.PURCHASE_CLICK, {
    action,
    href,
    location,
    page_source: getPageSource(),
  })
